export const url = (
  language,
  page,
  section,
  isSection,
  absolute,
  absoluteSection
) =>
  absoluteSection
    ? `/${section}`
    : isSection
    ? section
      ? (!absolute ? `/${language}` : '') + (section ? `#${section}` : '')
      : (!absolute ? `/${language}` : '') + (page ? `#${page}` : '')
    : (!absolute ? `/${language}` : '') +
      (page ? `/${page}` : '') +
      (section ? `#${section}` : '')

/* eslint-disable */
export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
/* eslint-enable */
